<template>
  <aside class="knowledge-sidebar">
    <h3 class="knowledge-sidebar__title">
      本体类型
      <span class="knowledge-sidebar__count">({{ totalCount }})</span>
    </h3>

    <ul class="knowledge-sidebar__list">
      <li
        v-for="item in types"
        :key="item.key"
        class="knowledge-sidebar__item"
        :class="{ 'knowledge-sidebar__item--active': activeType === item.key }"
      >
        <button type="button" class="knowledge-sidebar__btn" @click="toggleType(item.key)">
          <span class="knowledge-sidebar__label">{{ item.label }}</span>
          <span class="knowledge-sidebar__meta">
            <span class="knowledge-sidebar__item-count">{{ formatCount(item.count) }}</span>
          </span>
        </button>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'KnowledgeSidebar',
  props: {
    types: {
      type: Array,
      default: () => []
    },
    activeType: {
      type: String,
      default: ''
    }
  },
  computed: {
    totalCount() {
      return this.types.reduce((sum, item) => sum + item.count, 0)
    }
  },
  methods: {
    formatCount(num) {
      return num.toLocaleString()
    },
    toggleType(key) {
      this.$emit('update:activeType', this.activeType === key ? '' : key)
    }
  }
}
</script>

<style lang="scss" scoped>
.knowledge-sidebar {
  width: 220px;
  flex-shrink: 0;
  background: rgba($color-cream, 0.95);
  border-radius: 4px;
  padding: $spacing-base;
  box-shadow: 0 2px 12px rgba($color-brown-dark, 0.06);
  align-self: flex-start;
  position: sticky;
  top: calc($header-height + $spacing-base);

  &__title {
    font-size: rem(15);
    font-weight: 600;
    color: $color-brown-dark;
    padding-bottom: $spacing-md;
    border-bottom: 1px solid $color-border;
    margin-bottom: $spacing-sm;
  }

  &__count {
    font-weight: 400;
    font-size: rem(13);
    color: $color-text-light;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: $spacing-xs;
  }

  &__item {
    border-radius: 4px;
    overflow: hidden;

    &--active {
      .knowledge-sidebar__btn {
        background: rgba($success-color, 0.12);
        color: $success-color;
      }
    }
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: $spacing-md $spacing-sm;
    font-size: rem(14);
    color: $color-text;
    border-radius: 4px;
    transition: background 0.2s;

    &:hover {
      background: rgba($color-brown-dark, 0.06);
    }
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: $spacing-xs;
  }

  &__item-count {
    font-size: rem(12);
    color: $color-text-light;
  }
}

@media (max-width: 960px) {
  .knowledge-sidebar {
    width: 100%;
    position: static;
  }
}
</style>
